import type { ErrorProps } from "next/error";

import type { ReactElement, ReactNode } from "react";

import type { NextPage } from "next";

import Page404 from "./404";
import Page500 from "./500";

export type NextPageWithLayout = NextPage & {
  getLayout?: (_page: ReactElement, _options: any) => ReactNode;
};

type MyErrorPageProps = ErrorProps & {};

const Error = ({ statusCode }: MyErrorPageProps) => {
  if (statusCode == 404) return <Page404 />;

  return <Page500 statusCode={statusCode} />;
};

export default Error;
